import MicroModal from 'micromodal';
import Swiper, { Navigation, Pagination, Thumbs, EffectFade } from 'swiper';
//import Swiper from 'swiper/bundle';


export class Modal {
    constructor() {
        // this.body = document.getElementsByTagName('body')[0];
        // this.html = document.getElementsByTagName('html')[0];
        this.modalElem = {};
        this.sliderLeft = {};
        this.sliderRight = {};
    }

    init() {
        if (document.querySelectorAll('.modal-open')[0]) {
            //console.info('micromodal init');
            //is-open
            MicroModal.init({
                onShow: (modal) => this.initSwiper(modal.id),
                onClose: (modal) => this.destroySwiper(modal.id),
                disableScroll: true,
                //awaitOpenAnimation: true,
                //awaitCloseAnimation: true,
                debugMode: true,
            });
        }
    }

    initSwiper(modalId){
        //console.info(`initSwiper:modalId= ${modalId}`);

        //console.info(`${modalId} is shown`);
        this.modalElem = document.getElementById(modalId);

        //ハッシュ
        history.replaceState(null, null, window.location.pathname + '#' +modalId)


        if(this.modalElem.classList.contains('.initialized')){
            //初期化済み
        }else{

            //初期化、イベント追加
            this.modalElem.classList.add('.initialized');


            //.swiper--left
            const sliderLeftElem  = this.modalElem.querySelector('.swiper--left');
            this.sliderLeft = new Swiper(sliderLeftElem, {
                modules: [ Navigation, EffectFade ],
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove: false,
                autoplay: false,
                //direction: "vertical",
                //direction: "horisontal",
                speed: 300,
                loop: false,
                // thumbs: {
                //     swiper: this.sliderRight
                // },
                // on: {
                //     init: () => {
                //         console.log(this.sliderRight);
                //     }
                // }
            });

            // 右 thumbバージョン
            const sliderRightElem = this.modalElem.querySelector('.slide-thumb');
            let thumbs =  sliderRightElem.querySelectorAll('.slide-thumb-slide');
            thumbs[0].classList.add('selected');

            for (let j = 0; j < thumbs.length; j++) {
                thumbs[j].addEventListener('click', () => {
                    //console.log(`modalId:${modalId}, slideto: ${j}`);
                    //console.log(this.sliderLeft);
                    this.sliderLeft.slideTo(j);
                    for (let k = 0; k < thumbs.length; k++) {
                        if (j == k) {
                            thumbs[k].classList.add('selected');
                        } else {
                            thumbs[k].classList.remove('selected');
                        }
                    }
                });
            }
        }
    }

    destroySwiper(modalId){
        //console.info(`destroySwiper:modalId= ${modalId}`);

        //ハッシュ
        var hashString = location.hash.substring(1);
        //history.replaceState(null, null, window.location.pathname);
        history.pushState('', document.title, window.location.pathname);

        //console.log(window.location.pathname);

        //swiper destroy
        this.sliderLeft.destroy(true,true);//destroy(deleteInstance, cleanStyles)
        this.modalElem.classList.remove('.initialized');

        //swiper css reset
        const sliderRightElem = this.modalElem.querySelector('.slide-thumb');
        let thumbs =  sliderRightElem.querySelectorAll('.slide-thumb-slide');
        for (let j = 0; j < thumbs.length; j++) {
            thumbs[j].classList.remove('selected');
        }
    }

}